import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Tooltip,
  Chip,
} from "@mui/material";
import { CloudUpload, InfoOutlined } from "@mui/icons-material";
import AutoComplete from "../AutoComplete";
import ReactCountryFlag from "react-country-flag";
import Dropzone from "react-dropzone";
import CountryAutoComplete from "../CountryAutoComplete";
import ContentCategoryAutoComplete from "../layout/ContentCategoryAutoComplete";
import { SelectInput } from "../SelectInput";
import TextInput from "../TextInput";
import CkEditoComponent from "./CkEditorComponent";
import {
  Close,
  Doller,
  EditThumbnail,
  InfoEmail,
  Line,
  Search,
  UploadIcon,
} from "../../assets/icons";
import { colors } from "../../styles/color";
import {
  fetchCountryeDetails,
  setCountryState,
} from "../../redux/features/country/countrySlice";
import {
  fetchCategoryDetails,
  setCategoryState,
} from "../../redux/features/channelCategory/channelCategorySlice";
import {
  fetchAudioDetails,
  setAudioState,
} from "../../redux/features/channelAudioList/channelAudioSlice";
import { fetchAccountCreate } from "../../redux/features/addAccount/addAccountSlice";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContentCategoryDetails,
  setContentCategory,
} from "../../redux/features/contentCategory/contentCategorySlice";
import { ToastMessage } from "../../helpers/ToastMessage";
import { toast } from "react-toastify";
import { durationTime } from "../../constants/menuItems";
import { fetchDelectAccount } from "../../redux/features/deleteAccount/deleteAccountSlice";
import { setLoading } from "../../redux/features";
import {
  fetchAccountDeatils,
  setAccountDetailsState,
} from "../../redux/features/accountDetail/accountDetailSlice";
import {
  fetchProfileDetails,
  setProfileState,
} from "../../redux/features/profile/profileSlice";
import {
  onlyNumbers,
  validateMinSec,
} from "../../utils/commanFunctions/commanFunctions";
import ErrorTextBox from "./ErrorTextBox";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

interface Props {
  show?: boolean;
  setShow?: any;
  cameFromAccountSetup?: boolean;
}
interface FormErrors {
  name?: string;
  category?: string;
  uploadTime?: string;
  country?: any;
  language?: string;
  addChannel?: string;
  email?: string;
  description?: string;
  file?: string;
  valueData?: string;
  videoType?: any;
  contentCat?: any;
}
const InstaChannel = ({ show, setShow, cameFromAccountSetup }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const { audioData } = useSelector((state: any) => state?.audio);
  const [language, setLanguage] = useState<any[]>([]);
  const [uploadTime, setUploadTime] = useState<any>();
  const { countryData } = useSelector((state: any) => state.country);
  const [country, setCountry] = useState<any[]>([]);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [countryOptions, setCountryOptions] = useState<any[]>([]);
  const { categoryData } = useSelector((state: any) => state?.category);
  const [category, setCategory] = useState<any>("");
  const [valueData, setValueData] = useState("");
  const [minimumPrice, setMinimumPrice] = useState<any>();
  // const [bothFiled, setIsBothField] = useState(false);
  // const [isVideoFieldDisplay, setIsVideoFieldDisplay] = useState(false);
  // const [isShortVideoDisplay, setIsShortVideoDisplay] = useState(false);
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState<any>("");
  const [contentCat, setContentCat] = useState<any[]>([]);
  const [contentCatData, setContentcatData] = useState<any[]>([]);
  const [name, setName] = useState<string>("");
  // const [videoType, setVideoType] = useState<any>("1");
  const token = localStorage.getItem("instagramCode");
  console.log("token: ", token);
  const validTLDs = [
    "com",
    "org",
    "net",
    "gov",
    "edu",
    "mil",
    "int",
    "eu",
    "us",
    "uk",
    "ca",
    "jp",
    "cn",
    "au",
  ];
  const validTLDRegex = new RegExp(`(${validTLDs.join("|")})$`, "i");
  const handleDrop = React.useCallback((acceptedFiles: File[]) => {
    setFormErrors((prev) => ({
      ...prev,
      file: "",
    }));

    const data: any = acceptedFiles && acceptedFiles[0];

    if (data) {
      const fileSize = data.size;
      var fileSizes = Math.round(fileSize / 1024);
      if (fileSizes > 1024 * 5) {
        ToastMessage({
          type: "error",
          message: "Please select a file less than 5MB.",
        });
      } else {
        setFile(data);
      }
    }
  }, []);
  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .test("valid-email", "Invalid email address", (value) => {
        if (value) {
          const parts = value.split("@");
          if (parts.length === 2) {
            const username = parts[0];
            const domain = parts[1];

            if (
              username === "" ||
              username.startsWith(".") ||
              domain.startsWith(".") ||
              username.includes("..") ||
              domain.includes("..") ||
              domain.startsWith("-") ||
              username.endsWith(".") ||
              !/^[ -~\t\n\r]+$/.test(value)
            ) {
              return false;
            } else if (domain.startsWith("[") && domain.endsWith("]")) {
              const ip = domain.substring(1, domain.length - 1);
              if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(ip)) {
                const parts = ip.split(".");
                for (let part of parts) {
                  if (parseInt(part) < 0 || parseInt(part) > 255) {
                    return false;
                  }
                }
                return true;
              }
            } else if (domain.includes(".")) {
              const domainParts = domain.split(".");
              const tld = domainParts[domainParts.length - 1];

              if (validTLDRegex.test(tld) || tld === "name") {
                return true;
              }
            }
            return false;
          }
          return false;
        }
        return false;
      })
      .required("Email is required"),
    category: yup.string().required("Please select a category"),
    uploadTime: yup.string().required("Please select a upload time"),
    country: yup
      .array()
      .min(1, "Please select at least one country")
      .required("Please select a country"),
    language: yup
      .array()
      .min(1, "Please select at least one video audio language")
      .required("Please select video audio language"),
    description: yup
      .string()
      .min(10, "Description must be at least 10 characters")
      .required("Description is required"),
    contentCat: yup
      .array()
      .min(1, "Please select at least one content category")
      .required("Please select a content category"),
    file: yup.string().required("Drag and drop or browser to upload thumbnail"),
    valueData: yup
      .string()
      .test(
        "not-00-0e",
        'Value cannot be "00:0e" or contain invalid characters, only numbers are allowed',
        (value: any) => {
          if (value === "00:0e" || /[^\d:]/.test(value)) {
            return false;
          }
          return true;
        }
      ),
  });

  const handleClear = () => {
    setFile(null);
  };

  const handleContentcategory = (value: any) => {
    setContentCat(value);
    setFormErrors((prev) => ({
      ...prev,
      contentCat: "",
    }));
  };

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const res = await dispatch(fetchCountryeDetails());

        if (res && res.payload) {
          setCountryOptions(res.payload);

          dispatch(setCountryState(res.payload));
        } else {
          console.log("data is not found");
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };
    fetchCountryData();
  }, [dispatch]);

  useEffect(() => {
    const fetchAudioData = async () => {
      try {
        const res = await dispatch(fetchAudioDetails());
        dispatch(setAudioState(res));
      } catch (error) {
        console.log("Data is not found", error);
      }
    };

    fetchAudioData();
  }, []);

  useEffect(() => {
    const contentCategoryData = async () => {
      const data = await dispatch(fetchContentCategoryDetails(1));

      if (data) {
        setContentcatData(data?.payload);
      } else {
        toast.error("Data not found");
      }
    };
    contentCategoryData();
  }, []);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const data = await dispatch(fetchCategoryDetails(1)); // type=1 for Instagram
        dispatch(setCategoryState(data));

        console.log("Category API response: ", data);
      } catch (error) {
        console.log("Category data fetch error:", error);
      }
    };
    fetchCategoryData();
  }, [dispatch]);
  useEffect(() => {
    console.log("categoryData from Redux: ", categoryData);
  }, [categoryData]);

  const handleChange = (value: any) => {
    setCountry(value);
    setFormErrors((prev) => ({
      ...prev,
      country: "",
    }));
  };

  const handleLanguageChange = (value: any) => {
    setLanguage(value);
    setFormErrors((prev) => ({
      ...prev,
      language: "",
    }));
  };
  const getPlainText = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleSave = async () => {
    try {
      const validationData = {
        name,
        category,
        uploadTime,
        country,
        language,
        email,
        description: getPlainText(description),
        file,
        valueData,
        contentCat,
        // videoType
      };

      await schema.validate(validationData, { abortEarly: false });
      setFormErrors({});

      const formData = new FormData();
      if (!token) {
        return;
      }

      // formData.append("name[0]", name);
      formData.append("name", name);
      formData.append("category_id", category);
      formData.append("minimum_price", minimumPrice || "");
      formData.append("minimum_short_price", minimumPrice || "");
      formData.append("email", email);
      formData.append("video_length", valueData);
      formData.append("upload_time", uploadTime);
      formData.append("token_code", token);

      if (contentCat && contentCat.length > 0) {
        contentCat.forEach((contentCatDetails: any) => {
          formData.append("content_cat_id[]", contentCatDetails?.id);
        });
      }
      formData.append("video_type", "1");
      formData.append("auth_type", "0");

      if (country && country.length > 0) {
        country.forEach((c: any, index: number) => {
          formData.append("country[]", c.id);
        });
      }

      if (language && language.length > 0) {
        language.forEach((l: any, index: number) => {
          formData.append("audio_id[]", l.id);
        });
      }

      formData.append("description", description);

      // Append file if exists
      if (file) {
        formData.append("thumbnail", file);
      }

      const response = await dispatch(fetchAccountCreate(formData));
      if (response.payload) {
        // Refresh profile data to include the new Instagram account
        const profileResponse = await dispatch(fetchProfileDetails());
        if (profileResponse.payload) {
          dispatch(setProfileState(profileResponse.payload));
        }

        ToastMessage({
          type: "success",
          message: "Instagram account created successfully!",
        });

        // Navigate based on where the user came from
        if (cameFromAccountSetup) {
          // User came from account-setup, navigate to instagram-setup
          navigate("/instagram-setup");
        } else if (show) {
          // User came from dashboard, navigate back to dashboard
          navigate("/dashboard/social/instagram");
        } else {
          // Default fallback
          navigate("/instagram-setup");
        }

        localStorage.removeItem("instagramCode");
        dispatch(setLoading(false));
      } else {
        ToastMessage({
          type: "error",
          message: response.error.message,
        });
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      if (error.inner) {
        const errors: FormErrors = {};
        error.inner.forEach((err: any) => {
          errors[err.path as keyof FormErrors] = err.message;
        });
        setFormErrors(errors);
      } else {
        ToastMessage({
          type: "error",
          message: error.message || "Failed to create account",
        });
      }
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Box mt={0}>
            <TextInput
              title="Name"
              placeholder="Enter your name"
              value={name}
              textFieldStyle={{ height: "52px" }}
              onChange={(e) => {
                setName(e.target.value);
                setFormErrors((prev) => ({
                  ...prev,
                  name: "",
                }));
              }}
            />
            {formErrors.name && <ErrorTextBox>{formErrors.name}</ErrorTextBox>}
          </Box>
          {/* {isVideoFieldDisplay || bothFiled ? ( */}
          <Box
            sx={{
              mt: "24px",
              "& .MuiOutlinedInput-input": {
                pl: "20px",
              },
            }}
          >
            <TextInput
              title="Minimum Price for marketing (Optional)"
              placeholder="Enter minimum price"
              value={minimumPrice}
              textFieldStyle={{ height: "52px" }}
              onChange={(e: any) => {
                if (onlyNumbers(e?.target?.value) || e.target.value === "") {
                  if (e.target.value >= 1 || e.target.value === "") {
                    setMinimumPrice(Number(e?.target?.value));
                    setFormErrors((prev) => ({
                      ...prev,
                      minimumPrice: "",
                    }));
                  }
                }
              }}
              name="minimum_price"
              StartIcon={
                <Box display={"flex"} alignItems={"center"}>
                  <Box pr={"20px"}>
                    <Doller />
                  </Box>
                  <Box>
                    <Line />
                  </Box>
                </Box>
              }
            />
          </Box>
          {/* ) : ( */}

          {/* )} */}

          <Box mt={3}>
            <TextInput
              title="Average video upload duration in second (optional)"
              placeholder="05:50 min:sec"
              textFieldStyle={{ height: "52px" }}
              value={valueData}
              onKeyDown={(e: any) => {
                if (e.target.value.length === 2 && e.keyCode !== 8) {
                  if (e.target.value.indexOf(":") === -1) {
                    e.target.value = e.target.value + ":";
                  }
                  var str = e.target.value.split(":");
                  if (str[0].length === 1) {
                    e.target.value = "0" + str[0];
                  }
                }
              }}
              onChange={(e: any) => {
                let input = e.target.value;

                if (input !== "00:0e" && input.length <= 5) {
                  if (validateMinSec(input) || input === "") {
                    setValueData(input);
                    setFormErrors({
                      ...formErrors,
                      valueData: "",
                    });
                  } else {
                    setValueData(input);
                    setFormErrors({
                      ...formErrors,
                      valueData: "Invalid time format",
                    });
                  }
                } else if (input === "00:0e") {
                  setValueData(input);
                  setFormErrors({
                    ...formErrors,
                    valueData: 'Value cannot be "00:0e"',
                  });
                } else if (input === "") {
                  setValueData(input);
                  setFormErrors({
                    ...formErrors,
                    valueData: "",
                  });
                }
              }}
              name="minimum_price"
            />
          </Box>
          <ErrorTextBox>{formErrors.valueData}</ErrorTextBox>

          <Box
            mt={"24px"}
            sx={{
              "&::placeholder": {
                color: "#d32f2f",
                textAlign: "left",
                // fontSize: '12px',
                marginTop: "3px",
              },
            }}
          >
            <CountryAutoComplete
              placeholder={`${country?.length ? "" : "Select country"}`}
              title={"Target Audience Country"}
              options={countryOptions || []}
              EndIcon={<Search />}
              disableClearable
              value={country}
              getOptionLabel={(option: any) => option?.name}
              style={{height: "52px"}}
              onChange={(value) => handleChange(value)}
              renderTags={(value: any, getTagProps: any) =>
                value.map((option: any, index: any) => (
                  <Chip
                    key={option?.id}
                    label={option?.name}
                    {...getTagProps({ index })}
                    deleteIcon={<Close />}
                  />
                ))
              }
              renderOption={(props: any, option: any) => {
                return (
                  <Box
                    component="li"
                    sx={{
                      display: "flex",
                      "& .MuiAutocomplete-noOptions": {
                        color: colors.basics.white,
                      },
                      background: colors.dark[600],
                      "& .icons": {
                        width: "28px !important",
                        height: "28px !important",
                        borderRadius: "8px",
                      },
                    }}
                    {...props}
                  >
                    <Typography
                      mr="14px"
                      variant="body2"
                      alignItems={"center"}
                      display={"flex"}
                    >
                      <ReactCountryFlag
                        countryCode={option.code}
                        svg
                        className="icons"
                      />
                    </Typography>
                    <Typography variant="body2">{option.name} </Typography>
                  </Box>
                );
              }}
            />
            {formErrors.country && (
              <ErrorTextBox>{formErrors.country}</ErrorTextBox>
            )}
          </Box>
        </Grid>

        <Grid item sm={6} xs={12}>
          <SelectInput
            placeholder="Select Category"
            title="Instagram post/reels category"
            // '& muiItemPlaceholder': {
            //  fontSize: '12px',
            // },
            renderValue={(selected: any) => {
              if (selected === "") {
                return (
                  <Typography
                    variant="body2"
                    sx={{ color: colors.gray[500], fontSize: "14px" }}
                  >
                    {""}
                  </Typography>
                );
              }
              const selectedItem = categoryData?.find(
                (item: any) => item.id === selected
              );
              return selectedItem ? selectedItem.name : "";
            }}
            children={
              categoryData && Array.isArray(categoryData)
                ? categoryData.map((item: any) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        <Typography variant="body2" lineHeight="24px">
                          {item.name}
                        </Typography>
                      </MenuItem>
                    );
                  })
                : []
            }
            data={
              categoryData && Array.isArray(categoryData)
                ? categoryData.map((category: any) => category.name)
                : []
            }
            style={{height: "52px"}}
            onChange={(e) => {
              const categoryId = e.target.value;
              setCategory(categoryId);
              setFormErrors((prev) => ({
                ...prev,
                category: "",
              }));
            }}
            value={category}
            defaultOpen={false}
          />
          {formErrors.category && (
            <ErrorTextBox>{formErrors.category}</ErrorTextBox>
          )}

          {/* <Box mt={"24px"}>
            <Typography variant="body2" sx={{ color: "gray" }}>
              Video Type
            </Typography>

            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="all"
              name="radio-buttons-group"
              value={videoType}
              onChange={(event: any) => {
                setVideoType(event.target.value);
                if (event.target.value === "2") {
                  setIsVideoFieldDisplay(true);
                  setIsShortVideoDisplay(false);
                  setIsBothField(false);
                } else if (event.target.value === "3") {
                  setIsShortVideoDisplay(true);
                  setIsVideoFieldDisplay(false);
                  setIsBothField(false);
                } else if (event.target.value === "1") {
                  setIsBothField(true);
                  setIsShortVideoDisplay(false);
                  setIsVideoFieldDisplay(false);
                }
              }}
              sx={{
                "& .MuiRadio-root": {
                  color: colors.gray[500],
                },
                "& .Mui-checked": {
                  color: colors.basics.primary,
                  "& svg": {
                    fill: colors.basics.primary,
                  },
                },
                "& .MuiFormControlLabel-label": {
                  color: colors.gray[300],
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "21px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  backgroundColor: "#1D1D1D",
                  paddingY: "6px",
                  paddingX: "16px",
                  borderRadius: "8px",
                }}
              >
                <FormControlLabel value="1" control={<Radio />} label="Both" />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Full Video"
                />
                <FormControlLabel
                  value="3"
                  control={<Radio />}
                  label="Shorts (Reels)	"
                />
              </Box>
            </RadioGroup>
            <ErrorTextBox>{formErrors?.videoType}</ErrorTextBox>
          </Box> */}

          <Box
            mt={3}
            sx={{
              "&::placeholder": {
                color: "red",
              },
            }}
          >
            <ContentCategoryAutoComplete
              title={"Content Category"}
              options={contentCatData?.map((option: any) => option)}
              EndIcon={<Search />}
              disableClearable
              value={contentCat}
              getOptionLabel={(option: any) => option.name}
              style={{height: "52px"}}
              onChange={(value) => handleContentcategory(value)}
              renderTags={(value: any, getTagProps: any) =>
                value.map((option: any, index: any) => (
                  <Chip
                    key={option.id}
                    label={option.name}
                    {...getTagProps({ index })}
                    deleteIcon={<Close />}
                  />
                ))
              }
              renderOption={(props: any, option: any) => {
                return (
                  <Box
                    component="li"
                    sx={{
                      display: "flex",
                      "& .MuiAutocomplete-noOptions": {
                        color: colors.basics.white,
                      },
                      background: colors.dark[600],
                    }}
                    {...props}
                  >
                    <Typography
                      mr="14px"
                      variant="body2"
                      alignItems={"center"}
                      display={"flex"}
                    ></Typography>
                    <Typography variant="body2">{option.name} </Typography>
                  </Box>
                );
              }}
            />
            <ErrorTextBox>{formErrors?.contentCat}</ErrorTextBox>
          </Box>
          <Box mt={3}>
            <TextInput
              title="Contact Email"
              placeholder="Enter your email address"
              value={email}
              textFieldStyle={{ height: "52px" }}
              onChange={(e) => {
                setEmail(e.target.value);
                setFormErrors((prev) => ({
                  ...prev,
                  email: "",
                }));
              }}
              EndIcon={
                <Tooltip
                  className="custom-tooltip"
                  sx={{ background: "red" }}
                  placement="bottom-start"
                  title="Add an Email associated with your YouTube channel account."
                  arrow
                >
                  <InfoEmail />
                </Tooltip>
              }
            />
            {formErrors.email && (
              <ErrorTextBox>{formErrors.email}</ErrorTextBox>
            )}
          </Box>

          <Box mt={3}>
            <SelectInput
              title="Post/Reels upload duration time"
              placeholder="Select duration time"
              renderValue={(selected: any) => {
                if (selected === "") {
                  return (
                    <Typography
                      variant="body2"
                      sx={{ color: colors.gray[500] }}
                    >
                      {""}
                    </Typography>
                  );
                }
                const selectedItem = durationTime.find(
                  (item: any) => item.id === selected
                );
                return selectedItem ? selectedItem?.time : "";
              }}
              data={durationTime}
              style={{height: "52px"}}
              onChange={(e) => {
                const uploadTimeId = e?.target?.value;
                setUploadTime(uploadTimeId);
                setFormErrors((prev) => ({
                  ...prev,
                  uploadTime: "",
                }));
              }}
              value={uploadTime}
              defaultOpen={false}
              children={durationTime?.map((option: any, index: any) => {
                return (
                  <MenuItem
                    value={option?.id}
                    key={option?.id}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Typography
                      mr="14px"
                      variant="body2"
                      alignItems={"center"}
                      display={"flex"}
                    >
                      {option?.time}
                    </Typography>
                  </MenuItem>
                );
              })}
            />
            {formErrors.uploadTime && (
              <ErrorTextBox>{formErrors.uploadTime}</ErrorTextBox>
            )}
          </Box>
          <Box mt={3}>
            <CountryAutoComplete
              // open={true}
              title={"Post/Reels/Video audio language"}
              placeholder={`${language?.length ? "" : "Select language"}`}
              options={audioData?.map((option: any) => option)}
              EndIcon={<Search />}
              disableClearable
              value={language}
              getOptionLabel={(option: any) => option?.name}
              style={{height: "52px"}}
              onChange={(value) => handleLanguageChange(value)}
              renderTags={(value: any, getTagProps: any) =>
                value.map((option: any, index: any) => (
                  <Chip
                    key={option?.id}
                    label={option?.name}
                    {...getTagProps({ index })}
                    deleteIcon={<Close />}
                  />
                ))
              }
              renderOption={(props: any, option: any) => {
                return (
                  <Box
                    component="li"
                    sx={{
                      display: "flex",
                      "& .MuiAutocomplete-noOptions": {
                        color: colors.basics.white,
                      },
                      background: colors.dark[600],
                      "& .icons": {
                        width: "28px !important",
                        height: "28px !important",
                        borderRadius: "8px",
                      },
                    }}
                    {...props}
                  >
                    <Typography
                      mr="14px"
                      variant="body2"
                      alignItems={"center"}
                      display={"flex"}
                    >
                      <ReactCountryFlag
                        countryCode={option.code}
                        svg
                        className="icons"
                      />
                    </Typography>
                    <Typography variant="body2">{option.name} </Typography>
                  </Box>
                );
              }}
            />
            {formErrors.language && (
              <ErrorTextBox>{formErrors.language}</ErrorTextBox>
            )}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box mt={3}>
            <Typography variant="body2" color={colors.gray[300]}>
              Description
            </Typography>
            <Box
              sx={{
                "& .ck-editor ": {
                  backgroundColor: colors.dark[600],
                  padding: "20px",
                  borderRadius: "10px",
                  height: "120px",
                },
                ".ck.ck-editor__main>.ck-editor__editable": {
                  backgroundColor: "transparent",
                  border: 0,
                  height: "80px",
                },
                "& .ck-editor__top ": {
                  display: "none",
                },
                "& .ck-content p ": {
                  marginTop: "0 !important",
                  marginBottom: "15px !important",
                },
                "& .ck-content p a": {
                  color: "#A175FF !important",
                  textDecoration: "none",
                },
                "& .ck-content p:last-child ": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <div style={{ fontWeight: "500" }}>
                <CkEditoComponent
                  data={description}
                  setData={(value: string) => {
                    setDescription(value);
                    setFormErrors((prev) => ({
                      ...prev,
                      description: "",
                    }));
                  }}
                  placeholder={
                    "Write short description about Instagram account..."
                  }
                />
              </div>
            </Box>
            {formErrors.description && (
              <ErrorTextBox>{formErrors.description}</ErrorTextBox>
            )}
          </Box>

          <Box mt={"24px"}>
            <Box mb={"10px"}>
              <Typography
                variant="body2"
                lineHeight={"140%"}
                color={colors.gray[300]}
              >
                Upload Thumbnail
              </Typography>
            </Box>
            <Dropzone
              accept={{ "image/png": [".png", ".jpeg", ".jpg"] }}
              onDrop={handleDrop}
              // accept={['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/*']}
            >
              {({ getRootProps, getInputProps }) => (
                <Box
                  {...getRootProps()}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                    justifyContent: "left",
                    padding: file ? "0px" : "25px",
                    border: file ? "none" : `1px dashed ${colors.dark[100]}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    position: "relative",
                    // width: "100%",
                    overflow: "hidden",
                  }}
                >
                  <input {...getInputProps()} accept="image/*" />
                  {file ? (
                    <Box
                      sx={{
                        position: "relative",
                        textAlign: "left",
                        justifyContent: "left",
                        display: "flex",
                        width: "fit-content",
                      }}
                    >
                      <Box
                        sx={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          position: "relative",
                        }}
                      >
                        <img
                          src={file ? URL?.createObjectURL(file) : file}
                          alt="Preview"
                          style={{
                            maxWidth: "166px",
                            maxHeight: "166px",
                            borderRadius: "8px",
                          }}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            background: "#1d1d1d99",
                            transform: "translate(-50%, -50%)",
                            top: "50%",
                            left: "50%",
                            borderRadius: "8px",
                            cursor: "pointer",
                            p: "8px 8px 8px 8px",
                            textAlign: "left",
                            justifyContent: "left",
                            display: "flex",
                          }}
                          onClick={handleClear}
                        >
                          <EditThumbnail />
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box textAlign={"center"}>
                      <Box>
                        <UploadIcon />
                      </Box>
                      <Box>
                        <Typography variant="body2" lineHeight={"24px"}>
                          Drag and drop or browse
                        </Typography>
                        <Typography
                          variant="body2"
                          fontSize={"14px"}
                          lineHeight={"140%"}
                          color={colors.gray[300]}
                        >
                          Image size should be 1080px x 1080px (Max. File size:
                          5MB)
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </Dropzone>
            {formErrors.file && <ErrorTextBox>{formErrors.file}</ErrorTextBox>}
          </Box>

          <Box mt={3} display="flex" justifyContent="center">
            <Button
              variant="contained"
              sx={{
                backgroundColor: colors.basics.primary,
                width: { sm: "180px", xs: "100%" },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export { InstaChannel };
